// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Employee State
// -------------------------------
export interface EmployeeState extends EntityState<any> {
  common?: any;
  employeeList: Array<any>;
  employeeDetails: any;
  employeeLookup: Array<any>;
  employeeAllList: Array<any>;
}

// -------------------------------
//  Employee Adapter
// -------------------------------
export const employeeAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Employee Initial State
// -------------------------------
export const initialState: EmployeeState = employeeAdapter.getInitialState(
  {
  common: null,
  employeeList: [],
  employeeDetails:  {},
  employeeLookup: [],
  employeeAllList: [],
  },
);
